import { ApplicationConfig, LOCALE_ID, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { sourceInterceptor } from '@/interceptors/source.interceptor';
import { tokenInterceptor } from '@/interceptors/token.interceptor';
import { AuthenticationNavigationService } from '@/services/authentication-navigation.service';
import { TabPersistenceService } from '@/services/tab-persistence.service';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { routes } from './app.routes';

registerLocaleData(localeNl);

ModuleRegistry.registerModules([AllCommunityModule]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAngularSvgIcon(),
    provideFlatpickrDefaults({}),
    provideHttpClient(withInterceptors([tokenInterceptor, sourceInterceptor])),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: 'en',
    }),
    { provide: LOCALE_ID, useValue: 'nl' },
    provideAppInitializer(() => {
      // redirect to login page after user logs out or when the token expires
      inject(AuthenticationNavigationService);
    }),
    // Returning the promise makes Angular wait, so the tab layout is in place before the first
    // change detection: no flash of an empty workspace, and no spurious undo-stack entry.
    provideAppInitializer(() => inject(TabPersistenceService).hydrate()),
  ],
};
